import React, {useEffect, useRef, useState} from "react";
import {Layout} from "antd";
import "./dashboard-layout.scss";
import {Outlet, useLocation} from "react-router";
import ThemeModals from "../components/common/modals/theme-modals/ThemeModals";
import Footer from "../views/website/home/footer/Footer";
import MegaMenu from "../components/website/header/HeaderClone";
import WhatsAppWidget from "../components/whatsapp-widget/WhatsappWidget";

const { Content } = Layout;

export default function WebLayout() {
    const location = useLocation();
    const footerRef = useRef(null);
    const [currentRoute, setCurrentRoute] = useState("");
    const [social, setSocial] = useState(false);
    const [showWhatsApp, setShowWhatsApp] = useState(true);

    useEffect(() => {
        setCurrentRoute(location.pathname);
    }, [location]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setShowWhatsApp(!entry.isIntersecting);
            },
            { threshold: 0.1 }
        );

        if (footerRef.current) {
            observer.observe(footerRef.current);
        }

        return () => {
            if (footerRef.current) {
                observer.unobserve(footerRef.current);
            }
        };
    }, []);

    return (
        <Layout className="dashboard-layout">
            <Layout>
                <MegaMenu />
                <Outlet />
                <Footer footerRef={footerRef} />
                <div className={''} style={{overflow:'hidden'}}>
                    {showWhatsApp && <WhatsAppWidget />}
                </div>

            </Layout>

            <ThemeModals open={social} close={setSocial} title={"Share"} />
        </Layout>
    );
}
